import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  padding: ${(p) => p.theme.spacing(0, 1.5, 1, 1.5)};
  border: none;
  border-bottom: none;
`;

export const ViewRecords = styled(Stack)`
  flex-direction: row;
  font-size: ${(p) => p.theme.typography.caption.fontSize};
  font-weight: ${(p) => p.theme.typography.fontWeightSemiBold};
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
  cursor: pointer;
  &.viewRecordState {
    color: ${(p) => p.theme.palette.primary[500]};
  }
`;
